<svg
  [attr.viewBox]="viewBox"
  [attr.height]="height"
  [attr.width]="width"
  [style.height.px]="height"
  [style.width.px]="width"
  xmlns="http://www.w3.org/2000/svg"
  aria-label="Fraction"
>
  <text
    *ngIf="!useTextInput"
    x="50%"
    y="25%"
    dominant-baseline="middle"
    text-anchor="middle"
    [attr.fill]="color"
    [attr.font-size]="fontSize / 2"
    [attr.font-family]="fontFamily"
    [attr.font-weight]="fontWeight"
  >
    {{ value }}
  </text>

  <svg x="0" y="10%" width="100%" height="30%">
    <foreignObject
      class="input-wrapper"
      *ngIf="useTextInput"
      x="0"
      y="0"
      width="100%"
      height="100%"
    >
      <body xmlns="http://www.w3.org/1999/xhtml">
        <input
          type="text"
          class="input"
          gameFocus
          msVirtualKeyboard
          [formControl]="valueControl"
          [style.font-size.px]="fontSize / 2"
          [style.font-family]="fontFamily"
          [style.font-weight]="fontWeight"
          [style.color]="color"
          [readonly]="readonly"
        />
      </body>
    </foreignObject>
  </svg>
</svg>
